import {logger} from 'yougile-util'
import {WebStorageShape} from './web-storage'

interface RawCacheShape {
  init(): void
  write(companyId: string, item: string): void
  read(companyId: string): string
  clean(companyId: string): void
  cleanAll(): void
}

export interface CacheInitOptions {
  cache?: RawCacheShape
  storage?: WebStorageShape
}

export class Cache {
  private static cache: RawCacheShape
  private static storage: WebStorageShape

  public static init({cache, storage}: CacheInitOptions) {
    Cache.cache = cache
    Cache.storage = storage

    if (Cache.cache) {
      Cache.cache.init()
    } else if (!Cache.storage) {
      throw new Error('Cache.constructor: no cache provider registered')
    }
  }

  public static isValid(): boolean {
    return !!(Cache.cache || Cache.storage)
  }

  public static async write(companyId: string, item: string): Promise<void> {
    if (Cache.cache) {
      Cache.cache.write(companyId, item)
    } else if (Cache.storage) {
      await Cache.storage.set(companyId, item)
    } else {
      throw new Error('Cache.write: no cache provider registered')
    }
  }

  public static async read(companyId: string): Promise<string> {
    if (Cache.cache) {
      return Cache.cache.read(companyId)
    } else if (Cache.storage) {
      return Cache.storage.get<string>(companyId)
    } else {
      logger.warn('error', companyId, Cache.cache)
      throw new Error('Cache.read: no cache provider registered')
    }
  }

  public static async clean(companyId: string): Promise<void> {
    if (Cache.cache) {
      Cache.cache.clean(companyId)
    } else if (Cache.storage) {
      await Cache.storage.remove(companyId)
    } else {
      throw new Error('Cache.write: no cache provider registered')
    }
  }

  public static async cleanAll(): Promise<void> {
    if (Cache.cache) {
      logger.log('Clean all cache')
      Cache.cache.cleanAll()
    } else if (Cache.storage) {
      await Cache.storage.clear()
    } else {
      throw new Error('Cache.write: no cache provider registered')
    }
  }

  private static metadataKey(): string {
    return 'cached_metadata'
  }

  public static async writeMetadata(item: string): Promise<void> {
    return Cache.write(Cache.metadataKey(), item)
  }

  public static async readMetadata(): Promise<string> {
    return Cache.read(Cache.metadataKey())
  }

  public static async cleanMetadata(): Promise<void> {
    return Cache.clean(Cache.metadataKey())
  }
}
